/**
 * One colour of the brand: the colour, its name, its value and what it's for. The value is read from the live token,
 * so the page can never show a hex the app doesn't use.
 */
import { useEffect, useState } from 'react'
import s from './Swatch.module.css'

export function Swatch({ name, token, use }: { name: string; /** A CSS custom property, e.g. `--brand-dusk`. */ token: `--${string}`; use: string }) {
  const [value, setValue] = useState('')
  useEffect(() => setValue(getComputedStyle(document.documentElement).getPropertyValue(token).trim().toUpperCase()), [token])
  return (
    <figure className={s.swatch}>
      <span className={s.colour} style={{ background: `var(${token})` }} aria-hidden="true" />
      <figcaption className={s.cap}>
        <span className={s.name}>{name}</span>
        <code className={s.value}>{value || token}</code>
        <span className={s.use}>{use}</span>
      </figcaption>
    </figure>
  )
}
